import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Alert, Card, Col, Row, Spinner } from "react-bootstrap";
import { getCompanyNews } from "../apis/CompanyNews";
import { buildNewsMeta } from "../utils/homeUtils";
import {AdUnitMultiplex} from "../components/AdComponent";

const formatDisplayDateTime = (value) => (value ? String(value).replace("T", " ") : "");

export default function NewsDetail() {
  const { id } = useParams();
  const location = useLocation();
  const stateNewsItem = useMemo(() => {
    const item = location.state?.newsItem;

    if (!item || String(item.documentid) !== String(id)) {
      return null;
    }

    return item;
  }, [id, location.state]);
  const [newsItem, setNewsItem] = useState(stateNewsItem);
  const [isLoading, setIsLoading] = useState(!stateNewsItem);
  const [error, setError] = useState("");

  useEffect(() => {
    if (stateNewsItem) {
      setNewsItem(stateNewsItem);
      setIsLoading(false);
      setError("");
      return;
    }

    let isMounted = true;

    setIsLoading(true);
    setError("");

    getCompanyNews(null, 1000, null, null)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (!isMounted) {
          return;
        }

        const source = Array.isArray(data) ? data : data?.data || [];
        const foundItem = source.find((item) => String(item.documentid) === String(id));

        if (!foundItem) {
          setError("뉴스를 찾을 수 없습니다.");
          setNewsItem(null);
          return;
        }

        setNewsItem(buildNewsMeta(foundItem));
      })
      .catch((fetchError) => {
        if (!isMounted) {
          return;
        }

        console.error("There was a problem with the fetch operation:", fetchError);
        setError("뉴스 상세 정보를 불러오지 못했습니다.");
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [id, stateNewsItem]);

  return (
    <div className="p-4 p-lg-5" style={{ maxWidth: "960px", margin: "0 auto" }}>
      <div className="mb-3">
        <Link to="/news" className="btn btn-outline-secondary fw-semibold">
          뉴스 목록으로
        </Link>
      </div>

      {isLoading ? (
        <Card>
          <Card.Body className="py-5 text-center">
            <Spinner animation="border" role="status" />
          </Card.Body>
        </Card>
      ) : error ? (
        <Alert variant="secondary" className="mb-0">
          {error}
        </Alert>
      ) : newsItem ? (
        <div style={{ maxWidth: "960px", margin: "0 auto" }}>
          <Row className="g-3 align-items-start">
            <Col xs={12} sm={12} md={12} lg={9} xl={9}>
            <Card>
              <Card.Header className="d-flex flex-column gap-2">
                <h3 className="mb-0">{newsItem.title}</h3>
              </Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3 gap-3">
                  <Link to={`/stock/${newsItem.ticker}`} className="fw-semibold text-decoration-none">
                    {newsItem.source}
                  </Link>
                  <div className="text-secondary fs-sm">
                    {formatDisplayDateTime(newsItem.reportdate)}
                  </div>
                </div>
                <p className="mb-0 text-secondary" style={{ whiteSpace: "pre-line", lineHeight: 1.7 }}>
                  {newsItem.body}
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={12} lg={3} xl={3}>
            <AdUnitMultiplex key="detail-ad" slot="8895777617" style={{minWidth: "320px"}}/>
          </Col>
        </Row>
      </div>
      ) : (
        <Alert variant="secondary" className="mb-0">
          뉴스를 찾을 수 없습니다.
        </Alert>
      )}
    </div>
  );
}
